document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-noise-product]').forEach(function (page) {
    var box = page.querySelector('[data-product-options]');
    var select = page.querySelector('[data-noise-variant-select]');
    var image = page.querySelector('[data-noise-main-image]');
    var variantsEl = page.querySelector('[data-noise-variants]');
    var imagesEl = page.querySelector('[data-noise-variant-images]');
    if (!box || !select || !variantsEl) return;

    var variants, imageMap = {};
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    try { imageMap = JSON.parse(imagesEl.textContent); } catch (e) {}

    var selected = {};

    function buttons(index) {
      return box.querySelectorAll('[data-option-index="' + index + '"]');
    }

    function selectButton(index, value) {
      buttons(index).forEach(function (b) {
        b.classList.toggle('is-selected', b.dataset.optionValue === value);
      });
      selected[index] = value;
    }

    function findVariant() {
      return variants.find(function (v) {
        if (!v.available) return false;
        return (v.options || []).every(function (value, index) {
          return selected[index] === undefined || selected[index] === value;
        });
      });
    }

    function setImage(variant) {
      if (!image || !variant) return;
      var info = imageMap[String(variant.id)];
      if (!info || !info.image) return;
      image.classList.add('is-changing');
      window.setTimeout(function () {
        image.src = info.image;
        image.removeAttribute('srcset');
        image.alt = info.alt || variant.title;
        image.classList.remove('is-changing');
      }, 100);
    }

    function applyVariant(variant) {
      if (!variant) return;
      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      setImage(variant);
    }

    // Start with BLACK and the first available Black size.
    var colorButtons = Array.prototype.slice.call(box.querySelectorAll('.noise-color-option'));
    var black = colorButtons.find(function (b) {
      return /black/i.test(b.dataset.optionValue || '');
    });
    var initialColor = black || colorButtons[0];

    if (initialColor) {
      var ci = Number(initialColor.dataset.optionIndex);
      selectButton(ci, initialColor.dataset.optionValue);

      var initialVariant = variants.find(function (v) {
        return v.available && (v.options || [])[ci] === initialColor.dataset.optionValue;
      });

      if (initialVariant) {
        (initialVariant.options || []).forEach(function (value, i) {
          selected[i] = value;
          var matchButton = Array.prototype.slice.call(buttons(i)).find(function (b) {
            return b.dataset.optionValue === value;
          });
          if (matchButton) selectButton(i, value);
        });
        applyVariant(initialVariant);
      }
    }

    box.querySelectorAll('.noise-color-option, .noise-size-option').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        var index = Number(button.dataset.optionIndex);
        var value = button.dataset.optionValue;
        selectButton(index, value);

        var variant = findVariant();

        // On color change, preserve the current size if possible.
        // If that exact combination does not exist, use the first available
        // variant for the selected color and update the size button.
        if (!variant && button.classList.contains('noise-color-option')) {
          variant = variants.find(function (v) {
            return v.available && (v.options || [])[index] === value;
          });

          if (variant) {
            (variant.options || []).forEach(function (v, i) {
              selected[i] = v;
              selectButton(i, v);
            });
          }
        }

        if (variant) applyVariant(variant);
      });
    });

    page.querySelectorAll('.noise-product-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!image) return;
        image.src = thumb.dataset.imageUrl;
        image.removeAttribute('srcset');
      });
    });
  });
});